import { ActionIcon, Avatar, Box, Button, Grid, Group, Loader, Paper, Text, UnstyledButton } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import React, { useState } from "react";
import { FaPlus, FaSignOutAlt } from "react-icons/fa";
import { DELETE_OAUTH, GET_ALL_OAUTHS, SAVE_OAUTH } from "../../services/oauths";
import Auth, { OAUTH } from '../oauth/oauth';
import { FaGoogleDrive } from "react-icons/fa6";

export default function GoogleDrive(){
    const [data, setData] = useState<any[]>([]);
    const [loadingSave, setLoadingSave] = useState<boolean>(false);

    const { connect } = Auth();

    const loadData = () => {
        GET_ALL_OAUTHS()
        .then((res) => {
            setData((res ?? []).filter(r => r.origin === "drive"))
        })
        .catch(err => {
            showNotification({title: "Ops.", message: err.message, color: 'red'})
        })
    }

    const disconnectOauth = (oauth) => {
        DELETE_OAUTH(oauth._id)
        .then(() => {
            loadData();
        })
        .catch(err => {
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }
    
    const handleSaveOauth = (code) => {
        setLoadingSave(true)
        
        SAVE_OAUTH({ origin: "drive", data: { code } })
        .then((res) => {
            setLoadingSave(false);
            showNotification({message: "Google Drive Conectado", color: 'green'});
            loadData();
        })
        .catch(err => {
            setLoadingSave(false)
            showNotification({title: "Ops.", message: err.message, color: 'red'})
        })
    }

    React.useEffect(() => { loadData() }, [])
    
    return <div style={{position: 'relative'}}>
        {
            (data ?? []).length === 0 &&
            <UnstyledButton disabled={loadingSave} style={{width: '100%'}} onClick={() => { connect(OAUTH.DRIVE, loadData) }}>
                <Paper p="xl" shadow="xs" style={{ border: '1px solid #DFDFDF', borderRadius: 5, backgroundColor: '#fdcf51' }}>
                    <Group>
                        {loadingSave ? <Loader size={30} /> : <FaGoogleDrive color="white" size={30} />}
                        <Box style={{flex: 1}}>
                            <Text size="xl" c="white" fw="bold">Conectar Google Drive</Text>
                        </Box>
                    </Group>
                </Paper>
            </UnstyledButton>
        }
            {(data ?? []).map(connection => (
                <Paper p="xl" shadow="xs" style={{backgroundColor: '#fdcf51'}}>
                    <Group style={{whiteSpace: 'nowrap', flexWrap: 'nowrap', overflowX: 'hidden'}}>
                        <FaGoogleDrive color="white" size={30} />
                        <Box style={{flex: 1}}>
                            <Text c="white" size="xl" fw="bold">{connection?.data?.me?.name} - {connection?.data?.me?.email}</Text>
                        </Box>
                        <ActionIcon
                            onClick={() => disconnectOauth(connection)}
                            color="gray"
                            variant="light"
                        >
                            <FaSignOutAlt />
                        </ActionIcon>
                    </Group>
                </Paper>
            ))}
            {/* <Grid.Col md={12}>
                <Button color="green" loading={loadingSave} leftIcon={<FaPlus />} onClick={() => {
                    connect(OAUTH.DRIVE, loadData);
                }}>Conectar Conta</Button>
            </Grid.Col> */}

    </div>
}
